module.exports = __webpack_public_path__ + "static/porfesr-93a08540d73a20953073a00a848a7d24.png";